"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BreadCrumpPage_1 = require("../breadCrumpPage/BreadCrumpPage");
var carModelPage_module_scss_1 = __importDefault(require("./carModelPage.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var Loader_1 = require("../loader/Loader");
var carModelGeneralInfo_1 = __importDefault(require("../carModelGeneralInfo/carModelGeneralInfo"));
var carModelComplectation_1 = __importDefault(require("../carModelComplectation/carModelComplectation"));
var carTechnicalChars_1 = __importDefault(require("../carTechnicalChars/carTechnicalChars"));
var carCompareTechnic_1 = __importDefault(require("../car\u0421ompareTechnic/carCompareTechnic"));
var carPhotoGallery_1 = __importDefault(require("../carPhotoGallery/carPhotoGallery"));
var react_redux_1 = require("react-redux");
var catalogCarSlice_1 = require("../../redux/slice/catalogCarSlice");
var selectors_1 = require("../../redux/selectors");
var CarModelPage = function () {
    var _a = (0, react_router_dom_1.useParams)(), brand = _a.brand, model = _a.model;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = (0, react_1.useState)(0), discount = _b[0], setDiscount = _b[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var _c = (0, react_redux_1.useSelector)(selectors_1.catalogCarSelector), catalogCar = _c.catalogCar, _d = _c.stateLoad, isLoading = _d.isLoading, error = _d.error;
    (0, react_1.useEffect)(function () {
        if (!model) {
            navigate('/error', { state: { message: 'Модель не найдена' } });
            return;
        }
        var modelId = model.split('_')[1];
        if (!modelId) {
            navigate('/error', { state: { message: 'Неверный формат модели' } });
            return;
        }
        console.log('Loading model:', { brand: brand, model: model, modelId: modelId });
        dispatch((0, catalogCarSlice_1.catalogCarLoader)(modelId));
    }, [dispatch, model, brand, navigate]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        if (catalogCar) {
            console.log('Car data loaded:', catalogCar);
            var configurations = (_c = (_b = (_a = catalogCar.car_catalog_configurations) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.configurations) === null || _c === void 0 ? void 0 : _c[0];
            if (configurations) {
                var getCreditDiscount = configurations.credit_discount || 0;
                var getTradeInDiscount = configurations.trade_in_discount || 0;
                var getUtilDiscount = configurations.recycling_discount || 0;
                setDiscount(getCreditDiscount + getTradeInDiscount + getUtilDiscount);
            }
        }
    }, [catalogCar]);
    console.log('Render state:', { isLoading: isLoading, error: error, hasCatalogCar: !!catalogCar });
    var renderContent = function () {
        var _a, _b, _c, _d;
        if (isLoading) {
            console.log('Rendering loader');
            return react_1.default.createElement(Loader_1.Loader, null);
        }
        if (error || !catalogCar) {
            console.log('Rendering error state:', { error: error, catalogCar: catalogCar });
            return (react_1.default.createElement("div", { className: carModelPage_module_scss_1.default.error_container },
                react_1.default.createElement("h2", null, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E\u0431 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435"),
                react_1.default.createElement("p", null, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043B\u0438 \u0432\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043F\u043E\u0437\u0436\u0435.")));
        }
        console.log('Rendering car content with:', {
            hasConfigurations: ((_a = catalogCar.car_catalog_configurations) === null || _a === void 0 ? void 0 : _a.length) > 0,
            hasImages: ((_b = catalogCar.car_catalog_images) === null || _b === void 0 ? void 0 : _b.length) > 0,
            hasEngines: ((_c = catalogCar.car_catalog_engines) === null || _c === void 0 ? void 0 : _c.length) > 0,
        });
        return (react_1.default.createElement("div", { className: carModelPage_module_scss_1.default.car_model_content },
            react_1.default.createElement(carModelGeneralInfo_1.default, __assign({}, catalogCar, { setDiscount: setDiscount, discount: discount })),
            ((_d = catalogCar.car_catalog_configurations) === null || _d === void 0 ? void 0 : _d.length) > 0 && (react_1.default.createElement(carModelComplectation_1.default, __assign({}, catalogCar, { discount: discount }))),
            catalogCar.car_catalog_images && catalogCar.car_catalog_images.length > 0 && (react_1.default.createElement(carPhotoGallery_1.default, __assign({}, catalogCar))),
            react_1.default.createElement(carTechnicalChars_1.default, __assign({}, catalogCar)),
            react_1.default.createElement(carCompareTechnic_1.default, null)));
    };
    return (react_1.default.createElement("div", { className: carModelPage_module_scss_1.default.container },
        react_1.default.createElement("div", { className: carModelPage_module_scss_1.default.page },
            react_1.default.createElement(BreadCrumpPage_1.BreadCrumpPage, { links: [
                    { name: 'Главная', url: '/' },
                    { name: 'Каталог', url: '/catalog' },
                    { name: brand || '', url: "/catalog/".concat(brand) },
                    { name: (model === null || model === void 0 ? void 0 : model.split('_')[0]) || '', url: "/catalog/".concat(brand, "/").concat(model) },
                ] }),
            react_1.default.createElement("div", { className: carModelPage_module_scss_1.default.car_model_container }, renderContent()))));
};
exports.default = CarModelPage;
